// extracted by mini-css-extract-plugin
export default {"related":"Related_related__OJ46P","cards":"Related_cards__ayBdj","card":"Related_card__JFd7H","title":"Related_title__Ztgsu"};